import React, { useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { SFHotelReservaCancelarDo } from "services/services-mia/SFHotelReservaCancelarDo";

export default function CancelarReservaModal({
    reserva,
    updateList,
    closeModal,
    setterRowSelected,
}) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);

    const handleCancel = async () => {
        const SFHabitacionHuespedId = reserva?.SFHabitacionHuespedId ?? reserva?.id;
        if (!SFHabitacionHuespedId) return;
        setInRequest(true);
        const response = await SFHotelReservaCancelarDo(credentials, {
            SFHabitacionHuespedId,
        });
        setInRequest(false);
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Reserva cancelada correctamente",
                severity: "success",
                open: true,
            });
            setterRowSelected({ status: false, row: {} });
            closeModal();
            updateList();
        }
    };

    const huesped = [reserva?.usuarioApellidos, reserva?.usuarioNombres]
        .filter(Boolean)
        .join(", ");

    return (
        <div className={styles.inputs}>
            <div className={styles.column}>
                <p style={{ margin: 0 }}>
                    ¿Confirmás cancelar la reserva
                    {huesped ? ` de ${huesped}` : ""} en la habitación{" "}
                    {reserva?.habitacionNumero ?? "-"}?
                </p>
                <FormButton
                    inRequest={inRequest}
                    newFormData={{ button: "Cancelar reserva" }}
                    onClick={handleCancel}
                    onCloseModal={closeModal}
                    ignoreSnackbar
                />
                {inRequest && <CircularIndeterminate />}
            </div>
        </div>
    );
}
